export const base_url = "https://api.dynocrm.com/api/v1";
// export const base_url = "http://localhost:8000/api/v1";
